import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { createInitialState, LocationsState } from './location.state';
import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import { Location } from '@core/models/entities/location.models';
import {
  LoadLocationsPaginatedActions,
  LoadLocationsPaginatedMoreActions,
  Reset,
  ResetPartial,
  ResetQuery,
  AddLocation,
  PatchLocationAction,
  DeleteLocation,
} from './location.actions';

import { ReducerPaginatedUtils } from '@store/utils';
import { AuthActions } from '@features/auth/store';

export const LOCATIONS_FEATURE_KEY = 'locations';

const adapter: EntityAdapter<Location> = createEntityAdapter({
  selectId: ({ _id }) => _id,
});

export const initialState: LocationsState = adapter.getInitialState(createInitialState());

export const locationReducer: ActionReducer<LocationsState, Action> = createReducer(
  initialState,

  on(AuthActions.logout, () => initialState),

  on(PatchLocationAction.success, (state, { response }) =>
    adapter.updateOne(
      {
        id: response._id,
        changes: response,
      },
      {
        ...state,
        isProcessing: false,
      }
    )
  ),

  on(AddLocation.success, (state, { response }) =>
    adapter.addOne(response, {
      ...state,
      isProcessing: false,
    })
  ),

  on(DeleteLocation.success, (state, { response }) =>
    adapter.removeOne(response.id, {
      ...state,
      isProcessing: false,
    })
  ),
  on(LoadLocationsPaginatedActions.init, ReducerPaginatedUtils.handleLoad(adapter)),
  on(LoadLocationsPaginatedActions.success, ReducerPaginatedUtils.handleLoadSuccess(adapter)),
  on(LoadLocationsPaginatedActions.failure, ReducerPaginatedUtils.handleFailure(adapter)),
  on(LoadLocationsPaginatedMoreActions.init, ReducerPaginatedUtils.handleLoadMore()),
  on(LoadLocationsPaginatedMoreActions.success, ReducerPaginatedUtils.handleLoadMoreSuccess(adapter)),
  on(LoadLocationsPaginatedMoreActions.failure, ReducerPaginatedUtils.handleFailure(adapter)),
  on(Reset, () => initialState),
  on(ResetPartial, (state) => {
    return {
      ...initialState,
      queryParams: {
        ...initialState.queryParams,
        ...(state.queryParams?.query ? { query: state.queryParams.query } : {}),
      },
    };
  }),

  on(ResetQuery, (state) => {
    return { ...state, queryParams: { ...initialState.queryParams } };
  })
);

export const { selectAll: selectAllLocations, selectEntities: selectLocationsEntities } = adapter.getSelectors();
